import React from 'react';
import ReactDOM from 'react-dom/client';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';

import ConnectionRuns from './ConnectionRuns';
import ConnectionRunsTabState from './ConnectionRunsTabState';

export default class ConnectionRunsTabView extends BufferTabView<ConnectionRunsTabState> {
  reactRoot: ReactDOM.Root | null = null;

  override render(): this {
    const props = {
      connectionId: this.model.get('connectionId'),
    };
    this.reactRoot = renderToDOM(<ConnectionRuns {...props} />, this.el, this.reactRoot);
    return this;
  }

  override removeAsync(callback: () => void): BufferTabView<ConnectionRunsTabState> {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}

ConnectionRunsTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
